import { ThemeColors, ThemeNames, themes, ThemeWithHSL } from "@/config/theme";
import { hexToHSL } from "@/lib/utils/colors";
import { useCallback, useMemo } from "react";

export function useTheme(themeName: ThemeNames) {
  const convertThemeColors = useCallback((theme: ThemeColors): ThemeWithHSL => {
    try {
      return Object.entries(theme).reduce(
        (acc, [key, hexColor]) => ({
          ...acc,
          [key]: {
            hex: hexColor,
            hsl: hexToHSL(hexColor),
          },
        }),
        {} as ThemeWithHSL
      );
    } catch (error) {
      console.error("Failed to convert theme colors:", error);
      throw error;
    }
  }, []);

  return useMemo(() => {
    const theme = themes[themeName];
    if (!theme) {
      throw new Error(`Theme "${themeName}" not found`);
    }
    return convertThemeColors(theme);
  }, [themeName, convertThemeColors]);
}
